<script setup>
import { useReferenceWorkspace } from "./referenceWorkspace";
import * as Icon from "@heroicons/vue/24/solid";
const props = defineProps({ sidebar: Boolean });
const { visibleSections, relatedQuote, scrollToSection } =
  useReferenceWorkspace();
</script>

<template>
  <FormBox header="Jump To">
    <nav
      aria-label="Reference sections"
      :class="props.sidebar ? 'space-y-2' : 'flex flex-wrap gap-2'"
    >
      <button
        v-for="section in visibleSections"
        :key="section.id"
        type="button"
        class="rounded-xl border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:border-slate-600 dark:hover:bg-slate-700"
        :class="
          props.sidebar
            ? 'flex w-full items-center justify-between text-left'
            : 'shrink-0'
        "
        @click.prevent="scrollToSection(section.id)"
      >
        {{ section.label }}
        <Icon.ChevronRightIcon
          v-if="props.sidebar"
          class="h-4 w-4 text-slate-400"
        />
      </button>
    </nav>
    <router-link
      v-if="relatedQuote?.id"
      :to="`/quotes/${relatedQuote.id}`"
      class="mt-3 flex items-center justify-between rounded-xl border border-slate-200 px-4 py-3 text-sm text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:border-slate-600 dark:hover:bg-slate-700"
    >
      <div>
        <div
          class="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400"
        >
          Linked Quote
        </div>
        <div class="font-semibold text-slate-900 dark:text-slate-100">
          Quote #{{ relatedQuote.id }}
        </div>
      </div>
      <div
        class="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-slate-400"
      >
        <span>{{ relatedQuote.status }}</span>
        <Icon.ArrowTopRightOnSquareIcon class="h-4 w-4" />
      </div>
    </router-link>
  </FormBox>
</template>
